"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RequireInit = void 0;
const semaphore_1 = require("@shopify/semaphore");
/**
 * RequireInit decorator ensures that the init method is called before the target method is executed.
 * It also ensures that initialization happens only once using a mutex.
 * This decorator should only be used in classes that have an {@link Initable.init()} method.
 */
function RequireInit(_target, _propertyKey, descriptor) {
    const originalMethod = descriptor.value;
    // eslint-disable-next-line func-names, no-param-reassign
    descriptor.value = function (...args) {
        return __awaiter(this, void 0, void 0, function* () {
            const initable = this;
            // Setup facilities
            initable.mutex = initable.mutex || new semaphore_1.Semaphore(1);
            initable.initialized = initable.initialized || false;
            // Fast execute & return original method if already initialized
            if (initable.initialized) {
                return originalMethod.apply(this, args);
            }
            // Acquire the lock
            const permit = yield initable.mutex.acquire();
            try {
                // Double-check the initialization flag
                if (!initable.initialized) {
                    yield initable.init();
                    initable.initialized = true;
                }
            }
            finally {
                // Release the lock
                yield permit.release();
            }
            // Execute & return original method after initialized
            return originalMethod.apply(this, args);
        });
    };
}
exports.RequireInit = RequireInit;
